<template>
  <div class="card">
    <!-- <div class="card-header">
      <div class="row">
        <div class="col-md-8">
          <strong class="card-title mb-3">S1 (S)</strong>
        </div>
        <div class="col-md-3">
          <download :tableId="'s1s'" :fileName="'s1s'"></download>
        </div>
        <div class="col-md-1">
          <goback></goback>
        </div>
      </div>
    </div>-->
    <div class="card-body">
      <div class="row mb5">
        <div class="col-md-9 br">
          <!-- <filters @filter="filtData" :filterOptions="filterOptions"></filters> -->
          <!-- <filters @filter="filtData" :sectorData="sectorList" :pType="type"></filters> -->
          <div class="row">
            <div class="col-md-3">
              <div class="form-group">
                <datepicker
                  :input-class="'form-control'"
                  :format="'dd-MM-yyyy'"
                  v-model="ddate"
                  @selected="getDateData($event)"
                ></datepicker>
              </div>
            </div>
            <div class="col-md-3" v-if="searchData.length>0">
              <div class="form-group">
                <select class="form-control" v-model="selFilter[0]" name="raw-data-columns">
                  <option
                    v-for="(d, index) in filterOptions0"
                    v-bind:key="d.id+index"
                    :value="d.id"
                    disabled="disabled"
                  >{{d.value}}</option>
                </select>
              </div>
            </div>
            <div class="col-md-2" v-if="searchData.length>0">
              <div class="form-group">
                <!-- <label class="form-label">Max</label> -->
                <input class="form-control" v-model="minRange[0]" placeholder="Min" />
              </div>
            </div>
            <div class="col-md-2" v-if="searchData.length>0">
              <div class="form-group">
                <!-- <label class="form-label">Max</label> -->
                <input class="form-control" v-model="maxRange[0]" placeholder="Max" />
              </div>
            </div>

            <div class="col-md-3">
              <div class="form-group">
                <select class="form-control" name="sector" v-model="sectorname" @change="getS1Data">
                  <option value>Select Sector</option>
                  <option
                    v-for="(sec, index) in sectorData"
                    :value="sec.sect_name"
                    v-bind:key="sec.sect_code+index"
                    readonly
                  >{{sec.sect_name}}</option>
                </select>
              </div>
            </div>

            <div class="col-md-3" v-if="searchData.length>0">
              <div class="form-group">
                <select class="form-control" v-model="selFilter[1]" name="raw-data-columns">
                  <option
                    v-for="(d, index) in filterOptions1"
                    v-bind:key="d.id+index"
                    :value="d.id"
                    disabled="disabled"
                  >{{d.value}}</option>
                </select>
              </div>
            </div>
            <div class="col-md-2" v-if="searchData.length>0">
              <div class="form-group">
                <!-- <label class="form-label">Max</label> -->
                <input class="form-control" v-model="minRange[1]" placeholder="Min" />
              </div>
            </div>
            <div class="col-md-2" v-if="searchData.length>0">
              <div class="form-group">
                <!-- <label class="form-label">Max</label> -->
                <input class="form-control" v-model="maxRange[1]" placeholder="Max" />
              </div>
            </div>
            <div class="col-md-2" v-if="searchData.length>0"></div>
            <div class="col-md-3" v-if="searchData.length>0"></div>
            <div class="col-md-3" v-if="searchData.length>0">
              <div class="form-group">
                <select class="form-control" v-model="selFilter[2]" name="raw-data-columns">
                  <option
                    v-for="(d, index) in filterOptions2"
                    v-bind:key="d.id+index"
                    :value="d.id"
                  >{{d.value}}</option>
                </select>
              </div>
            </div>
            <div class="col-md-2" v-if="searchData.length>0">
              <div class="form-group">
                <input class="form-control" v-model="minRange[2]" placeholder="Min" />
              </div>
            </div>
            <div class="col-md-2" v-if="searchData.length>0">
              <div class="form-group">
                <input class="form-control" v-model="maxRange[2]" placeholder="Max" />
              </div>
            </div>

            <div class="col-md-1" v-if="searchData.length>0">
              <div class="form-group">
                <button @click="filtData" class="btn btn-sm btn-primary" type="button">
                  <i class="fa fa-filter" title="Filter"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <input
              class="form-control"
              v-model="searchText"
              placeholder="Search"
              @keyup="filteredList($event)"
            />
          </div>
        </div>
      </div>
      <!-- <div class="row mt-15">
        <div class="col-md-12">
          <pagination
            ref="page"
            :pageName="type"
            :totPages="totalPages"
            :apiUrl="rawDataApi"
            @changePage="pageChange"
          ></pagination>
        </div>
      </div>-->
      <div class="row mt-15">
        <div class="col-md-12">
          <!-- <pagination
            ref="page"
            :pageName="type"
            :totPages="totalPages"
            :apiUrl="rawDataApi"
            @changePage="pageChange"
          ></pagination>-->
          <div class="pull-right">
            <ul v-if="totalPages != 1" class="pagination">
              <li :class="{disabled:prevDisabled}" class="page-item">
                <a class="page-link" @click.prevent="goToPage(1)" href="#">{{'&lt;&lt;'}}</a>
              </li>
              <li :class="{disabled:prevDisabled}" class="page-item">
                <a class="page-link" @click.prevent="prev()" href="#">{{'&lt;'}}</a>
              </li>
              <li
                v-for="page in pages"
                v-bind:key="page"
                class="page-item"
                :class="(current_page == page)? 'active':''"
              >
                <a class="page-link" @click.prevent="goToPage(page)" href="#">{{page}}</a>
              </li>
              <li :class="{disabled:nextDisabled}" class="page-item">
                <a class="page-link" href="#" @click.prevent="next()">{{'&gt;'}}</a>
              </li>
              <li :class="{disabled:nextDisabled}" class="page-item">
                <a class="page-link" href="#" @click.prevent="goToPage(totalPages)">{{'&gt;&gt;'}}</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="table-responsive mb-15 app" v-dragscroll="true">
        <table id="s1s" class="table table-bordered app-inner" style="font-size: 11px;">
          <thead v-if="tableFields.length>0">
            <tr>
              <th>Sr.</th>
              <th
                @click="sortColumn(field, index)"
                style="font-size:.92em"
                class="data-cell column-sort"
                v-for="(field, index, key) in tableFields"
                v-bind:key="'field'+field+index+key"
              >
                {{field.name}}
                <span v-if="field.isSortable">
                  <i
                    class="fa fa-caret-down"
                    v-if="(field.sort_order == 1 || field.sort_order == 0)"
                  ></i>
                  <i
                    class="fa fa-caret-up"
                    v-else-if="(field.sort_order == 2 || field.sort_order == 0)"
                  ></i>
                </span>
              </th>
            </tr>
          </thead>
          <tbody v-if="tableFields.length>0">
            <tr v-for="(row, index, key) in rawData" v-bind:key="'row'+row+index">
              <td>{{(parseInt(page)===1)? (index+1):(((parseInt(page)-1)*perPage)+(index+1))}}</td>
              <td v-for="(field, ind) in tableFields" v-bind:key="ind+'-td-'+index+key">
                <span
                  v-if="field.title === 'q1_a_b_greater' || field.title === 'p11_quarterly_trends' || field.title === 'sector_name' || field.title === 'co_code' || field.title === 'name' || field.title === 'market_capitalization' || field.title === title"
                >
                  <span v-if="field.isLink">
                    <a class="a-btn" @click.prevent="showCompDetails(row)">{{ row[field.title]}}</a>
                  </span>
                  <span
                    v-else
                  >{{(field.isNumeric)? getChecknFixed(row[field.title]): row[field.title]}}</span>
                </span>
                <span v-else>
                  <span
                    v-if="field.title==='latest_cyclical'"
                    :class="(row['s1_data'][field.title] === 1)? 'fred': (row['s1_data'][field.title]===0)? 'fgreen': ''"
                  >{{(row['s1_data'][field.title] === 1)? 'Yes': (row['s1_data'][field.title]===0)? 'No': '-'}}</span>
                  <span v-else>
                    <span
                      v-if="row['s1_data']"
                      :class="(field.hasColor && row['color'][field.color])? 'f'+row['color'][field.color]: ''"
                    >{{(field.isNumeric)? getChecknFixed(row['s1_data'][field.title]): getLabel(row['s1_data'][field.title])}}</span>
                  </span>
                </span>
              </td>
            </tr>
          </tbody>
          <tfoot v-if="rawData.length===0">
            <tr>
              <td :colspan="tableFields.length">
                <div class="alert alert-danger" role="alert">No data found!</div>
              </td>
            </tr>
          </tfoot>
        </table>
        <!-- <div class="alert alert-danger" role="alert" v-else>No data found!</div> -->
      </div>
      <div class="row mt-15">
        <div class="col-md-6"></div>
        <div class="col-md-1" v-if="searchData.length>0">
          <download :tableId="'s1s'" :fileName="'s1s'"></download>
        </div>
        <div class="col-md-5">
          <!-- <pagination
            ref="page"
            :pageName="type"
            :totPages="totalPages"
            :apiUrl="rawDataApi"
            @changePage="pageChange"
          ></pagination>-->
          <div class="pull-right">
            <ul v-if="totalPages != 1" class="pagination">
              <li :class="{disabled:prevDisabled}" class="page-item">
                <a class="page-link" @click.prevent="goToPage(1)" href="#">{{'&lt;&lt;'}}</a>
              </li>
              <li :class="{disabled:prevDisabled}" class="page-item">
                <a class="page-link" @click.prevent="prev()" href="#">{{'&lt;'}}</a>
              </li>
              <li
                v-for="page in pages"
                v-bind:key="page"
                class="page-item"
                :class="(current_page == page)? 'active':''"
              >
                <a class="page-link" @click.prevent="goToPage(page)" href="#">{{page}}</a>
              </li>
              <li :class="{disabled:nextDisabled}" class="page-item">
                <a class="page-link" href="#" @click.prevent="next()">{{'&gt;'}}</a>
              </li>
              <li :class="{disabled:nextDisabled}" class="page-item">
                <a class="page-link" href="#" @click.prevent="goToPage(totalPages)">{{'&gt;&gt;'}}</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import http from "@/lib/http";
import { commonMixins } from "../../assets/mixins/common.js";
import { pCommonMixins } from "../../assets/mixins/pcommon.js";
import Datepicker from "vuejs-datepicker";

export default {
  components: { Datepicker },
  mixins: [commonMixins, pCommonMixins],
  props: ["sectorList", "mcFilter", "title"],
  created() {
    // let routeData = this.$router.resolve({ path: "/filtered-s1" });
    // console.log("this.$route.query.page", this.$route, routeData);
    // window.open(routeData.href, "_blank");
    this.getS1Data();
    this.selFilter[0] = "p11_actual";
    this.selFilter[1] = "q1_a_b_greater";
    this.selFilter[2] = "p11_quarterly_trends";
    this.minRange[0] = this.minRange[1] = this.minRange[2] = this.maxRange[0] = this.maxRange[1] = this.maxRange[2] =
      "";
    this.tableFields = this.s1Data;
  },
  data() {
    return {
      ddate: new Date().setDate(new Date().getDate() - 1),
      tableFields: [],
      rawDataApi: "getS1SumData",
      apiUrl: "",
      rawData: {},
      searchData: [],
      searchText: "",
      curYear: new Date().getFullYear(),
      minRange: [],
      maxRange: [],
      filterOptions: [
        {
          id: "",
          value: "Select",
          isNumeric: true,
          sort_order: 0
        }
      ],
      selFilter: [],
      selRangeFilter: 0,
      type: "s1",
      sectorData: [],
      sectorname: "",
      page: 1,
      perPage: 700,
      current_page: 1,
      pageToLoad: 1,
      totalPages: 1,
      prevDisabled: 1,
      nextDisabled: 0,
      pages: []
    };
  },
  methods: {
    getS1Data() {
      this.rawData = [];
      let myself = this;
      let data = {};
      data = {
        my_date: myself.getDate(myself.ddate),
        sector: myself.sectorname,
        m_filter: this.selFilter,
        min_range: this.minRange,
        max_range: this.maxRange,
        pageid: myself.page
      };
      // console.log("POST DATA", data);
      http.post(myself.rawDataApi, data, (error, response) => {
        if (response.data.length > 0) {
          // console.log("Data");
          if (this.page === 0) {
            this.page = 1;
          } else {
            myself.rawData = response.data; //.slice(0, 500);
            myself.searchData = response.data; //.slice(0, 500);
            myself.ddate = myself.rawData[0]
              ? new Date(myself.rawData[0].date)
              : myself.ddate;
            myself.tableFields = this.s1Data;
            myself.totalPages = response.total_pages ? response.total_pages : 1;
            let i = 8;
            let page = myself.current_page - 2;
            if (page <= 0) page = 1;
            myself.pages = [];
            while (i) {
              myself.pages.push(parseInt(page));
              if (myself.totalPages <= page) break;
              page++;
              i--;
            }
            //   console.log("PAges", myself.pages);
            this.tableFields.forEach((val, key) => {
              // console.log(key, val);
              if (
                val !== "date" &&
                val !== "_id" &&
                val !== "name" &&
                val !== "co_code" &&
                val !== "sector_name"
              ) {
                this.filterOptions.push({
                  id: val.title,
                  value: val.name,
                  isNumeric: val.isNumeric,
                  sort_order: key
                });
              }
            });
          }
        }
      });
    },
    pageChange(data) {
      this.page = data.page ? data.page : 1;
      this.getS1Data();
    },
    prev() {
      this.pageToLoad = this.current_page - 1;
      this.fillTable();
    },
    goToPage(page) {
      this.pageToLoad = page;
      this.fillTable();
    },
    next() {
      console.log(this.$route.query);
      this.pageToLoad = this.current_page + 1;
      this.prevDisabled = 0;
      this.fillTable();
    },
    fillTable() {
      this.page = this.pageToLoad;
      if (this.pageToLoad == this.totalPages) {
        this.nextDisabled = 1;
      } else {
        this.nextDisabled = 0;
      }
      if (this.pageToLoad == 1) {
        this.prevDisabled = 1;
      } else {
        this.prevDisabled = 0;
      }
      this.current_page = this.pageToLoad;
      this.getS1Data();
    },
    filtData(obj) {
      if (this.rawData.length > 0) {
        this.page = 0;
        this.ddate = new Date(this.ddate);
        localStorage.setItem("min", JSON.stringify(this.minRange));
        localStorage.setItem("date", this.ddate);
        localStorage.setItem("sector", this.sectorname);
        localStorage.setItem("max", JSON.stringify(this.maxRange));
        let routeData = this.$router.resolve({
          path: "/filtered-s1",
          params: { sectorList: this.sectorData }
        });
        window.open(routeData.href, "_blank");
      } else {
        this.page = 0;
        this.getS1Data();
      }
    },
    filterRangeData(event) {
      this.clearData();
      var ind = event.target.value;
      this.selRangeFilter = this.mcOptions[ind].id;
      if (this.selRangeFilter === 0) {
        this.rawData = this.searchData;
        return this.rawData;
      } else {
        var minRange = this.mcOptions[ind].min;
        var maxRange = this.mcOptions[ind].max;
        this.rawData = this.searchData.filter(rd => {
          // console.log(
          //   rd.market_capitalization,
          //   this.selRangeFilter,
          //   minRange,
          //   maxRange
          // );
          if (minRange != "" && maxRange != "") {
            return (
              parseInt(rd["market_capitalization"]) >= parseInt(minRange) &&
              parseInt(rd["market_capitalization"]) <= parseInt(maxRange)
            );
          } else {
            if (minRange != "") {
              return (
                parseInt(rd["market_capitalization"]) >= parseInt(minRange)
              );
            }
            if (maxRange != "") {
              return (
                parseInt(rd["market_capitalization"]) <= parseInt(maxRange)
              );
            }
          }
        });
      }
      setTimeout(() => {
        this.sortColumn(this.tableFields[2], 2);
      });
    },
    filteredList(e) {
      this.selRangeFilter = 0;
      this.selFilter = "";
      if (this.searchText === null || this.searchText === "") {
        this.rawData = this.searchData;
        return this.rawData;
      } else if (this.searchText.length <= 2) {
        this.rawData = this.searchData;
        return this.rawData;
      }
      if (this.searchText.length > 2 || e.keyCode === 13) {
        this.rawData = this.searchData.filter(rd => {
          return (
            rd.co_code.toLowerCase().includes(this.searchText.toLowerCase()) ||
            (rd.name
              ? rd.name.toLowerCase().includes(this.searchText.toLowerCase())
              : false)
          );
        });
      }
    },
    clearData() {
      this.selRangeFilter = 0;
      this.selFilter = "";
      this.sectorname = "";
      this.searchText = "";
      this.sectorname = "";
      this.searchText = "";
      this.selFilter[2] = "p11_quarterly_trends";
      this.ddate = new Date().setDate(new Date().getDate() - 1);
      this.minRange[0] = this.minRange[1] = this.minRange[2] = this.maxRange[0] = this.maxRange[1] = this.maxRange[2] =
        "";
      this.rawData = this.searchData;
    },
    getDateData(e) {
      console.log("Date Selected", e);
      this.ddate = e;
      this.getS1Data();
    }
  },
  watch: {
    sectorList(value) {
      this.sectorData = value;
    }
  },
  computed: {
    filterOptions0: function() {
      return this.filterOptions.filter(function(row, index) {
        return row.id === "p11_actual";
      });
    },
    filterOptions1: function() {
      return this.filterOptions.filter(function(row, index) {
        return row.id === "q1_a_b_greater";
      });
    },
    filterOptions2: function() {
      return this.filterOptions.filter(function(row, index) {
        return row.id === "p11_quarterly_trends";
        // return row.id === "q1_S" || row.id === "q1_a_S" || row.id === "q1_b_S" || row.id === "q1_c_S" || row.id === "q1_d_S";
      });
    }
  }
};
</script>
<style>
form .col-md-3 {
  width: 40%;
}

.table td {
  padding: 5px 10px 5px 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/market-data/s1-s.vue